var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.item.type == 'link')?_c('div',[_c('a',{staticClass:"pb-link",attrs:{"contenteditable":_vm.contenteditable,"href":_vm.link}},[_vm._v("\n    "+_vm._s(_vm.item.content)+"\n  ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }